import styles from './lib/scss/main.module.scss'
import coloursModule from './lib/scss/variables/colours'
import miscModule from './lib/scss/variables/misc'

export const colours = coloursModule
export const misc = miscModule

export default styles
